import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { UserValidations, UserPermissionsNormalize } from '../../../models';
import Button from '../../inputs/button/Button';
import AddForm from '../addform/AddForm';
import FormActions from '../formactions/FormActions';
import FormField from '../formfield/FormField';
import { getUpdatedPermissions } from '../../../constants/perms';
import { getPermissionLabels } from '../../../constants/perms';
export class AddUserForm extends Component {
  constructor(props) {
    super(props);
    let user = this.props.user;
    if (props.isEditType === true) {
      const userPermissionObj = getUpdatedPermissions(user, 'Object');
      if (user !== undefined) {
        this.props.initialize({
          userPermissions: userPermissionObj
        });
      }
    }
  }
  render() {
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        {this.props.isEditType === undefined && (
          <Field
            name="email"
            label={I18n.t('add.user.email.label')}
            type="text"
            placeholder={I18n.t('add.user.email.placeholder')}
            component={FormField}
            validate={UserValidations.email}
          />
        )}
        <Field
          name="sitetobeShown"
          label={I18n.t('add.user.site.label')}
          type="text"
          placeholder={this.props.sitetobeShown.label}
          component={FormField}
          readOnly={true}
        />

        <Field
          name="userPermissions"
          label={I18n.t('add.user.userPermissions.label')}
          type="multiselect"
          options={getPermissionLabels(this.props.userPermissions)}
          placeholder={I18n.t('add.user.userPermissions.placeholder')}
          component={FormField}
          validate={UserValidations.userPermissions}
          normalize={UserPermissionsNormalize.permissions}
        />

        <FormActions>
          <Button>{I18n.t('add.save')}</Button>
        </FormActions>
      </AddForm>
    );
  }
}

export default reduxForm({
  form: 'adduser'
})(AddUserForm);



// WEBPACK FOOTER //
// ./src/components/forms/adduserform/AddUserForm.js